import BaseChannel from "~/channels/BaseChannel";

export default class LegacyPublicAccountChannel extends BaseChannel {
  static channelName = "LegacyPublicAccountChannel";
}
